import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import type { Administration } from "../types/administration";

export function useAdministration(workspaceId: string | undefined) {
  const query = useQuery({
    queryKey: ["administration", workspaceId],
    queryFn: () => api<Administration>(`/${workspaceId}/administration`),
  });

  async function mutate(path: string, init: RequestInit) {
    await api(path, init);
    await query.refetch();
  }

  return { query, mutate };
}
